// TODO: Implement more complex business logic once mapping is ready.

export const FOA_NATIONAL_THRESHOLD_NOK = 1_300_000;
export const FOA_EEA_THRESHOLD_NOK = 2_200_000;

export const getThresholdInfo = (
  value: number | null,
  t: (key: string) => string
): { message: string; colorScheme: string } | null => {
  if (value === null) return null;
  if (value < FOA_NATIONAL_THRESHOLD_NOK) return { message: t("FOA Del I - Under nasjonal terskelverdi"), colorScheme: "info" };
  if (value <= FOA_EEA_THRESHOLD_NOK) return { message: t("FOA Del II - Over nasjonal terskelverdi"), colorScheme: "warning" };
  return { message: t("FOA Del III - Over EØS-terskelverdi"), colorScheme: "warning" };
};
